const models = [
    {text: 'Model 1', value: 'model_1'},
    {text: 'Model 2', value: 'model_2'}
]

export default models